import React, { useState } from 'react';

const Footer: React.FC = () => {
  const [showCookieNotice, setShowCookieNotice] = useState(true);

  return (
    <footer className="bg-white border-t border-neutral-200 text-neutral-700">
      <div className="container-max py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="text-sm text-neutral-500">
              Follow us on LinkedIn for the latest updates and insights.
            </p>
          </div>
          <a
            href="https://www.linkedin.com/company/zwift-labs/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-neutral-200 hover:border-neutral-900 text-black text-sm font-medium rounded-full transition-all"
          >
            <svg className="w-4 h-4 text-[#0077b5]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            Follow on LinkedIn
          </a>
        </div>
      </div>

      <div className="border-t border-neutral-200 py-6">
        <div className="container-max text-center">
          <p className="text-xs text-neutral-500">
            © 2025 Zwift Labs Limited · All rights reserved.
          </p>
        </div>
      </div>

      {showCookieNotice && (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md bg-white border border-neutral-200 rounded-2xl shadow-xl p-5 z-50">
          <div className="flex flex-col gap-4">
            <div className="text-sm text-neutral-700 leading-relaxed">
              <strong className="text-black">This website uses cookies.</strong> We use cookies to analyze traffic and optimize your experience.
            </div>
            <button
              onClick={() => setShowCookieNotice(false)}
              className="bg-black hover:bg-neutral-800 text-white text-sm font-medium px-5 py-2 rounded-full transition-colors self-start"
            >
              Accept
            </button>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
